<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="40">
            <h2>Documentation DO</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <div class id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showVisibility"
              class="md-button-color-toggle md-active"
              @click="showOverflow"
              v-bind:class="NocModel.ffDoId==''?'md-active':''"
              style
            >
              <span>DOCUMENTATION - RELEASE DELIVERY ORDER</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="70"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Current Date & Time</label>
                        <b-form-input :formatter="capitalizeAll" disabled v-model="NocModel.currentDate"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Importer Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="importerName"
                          name="importerName"
                          v-model="NocModel.importerName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Enter MBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="mblNo" name="mblNo" v-model="NocModel.mblNo"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Enter HBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo" v-model="NocModel.hblNo"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <hr class="hr-border" />
                  <div class="box">
                    <div class="box-header">
                      <h3 class="box-title">
                        <u>Container Detail</u>
                      </h3>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                      <table id="FreghtContaner" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Container No</th>
                            <th>Seal No</th>

                            <th>Package Detail</th>
                            <th>Gross Weight</th>
                            <th>Measurement(CBM)</th>
                            <!-- <th v-if="ExecutionDisable==''">Delete</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1,index) in getContainerList" :key="index">
                            <td>
                              {{item1.containerNo}}
                              <br />
                              {{item1.containerType}}
                            </td>

                            <td>{{item1.lineSealNo}}</td>
                            <td>{{item1.noOfPkg}} {{item1.packageName}}</td>
                            <td>{{item1.grossWeight}}</td>
                            <td>{{item1.measurement}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- /.box-body -->
                    <hr class="hr-border" />
                  </div>
                  <!-- <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="30">
                      <label>Container No./ Seal No.</label>
                      <quill-editor ref="containerSealNo" v-model="NocModel.containerSealNo"></quill-editor>
                    </md-layout>
                  </md-layout>-->
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Documentation Release Delievery Order</label>
                      </md-layout>
                      <md-layout md-flex="100">
                        <quill-editor
                          style="width:100% !important;height:520px !important"
                          v-model="NocModel.nocPreparation"
                        ></quill-editor>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <hr class="hr-border" />

                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>

                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="addNocDocumentation"
                        id="addButtonLoaderNoc"
                      >Save</md-button>
                      <md-spinner md-indeterminate id="loaderNoc" style="display:none"></md-spinner>
                    </md-layout>

                    <md-layout md-flex="15"></md-layout>
                    <md-layout md-flex="20" v-if="NocModel.ffDoId!=''">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="Print('DODoc',NocModel.uploadNocDoc)"
                        id="addButtonLoaderAuth"
                      >Print</md-button>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <!-- 




        <hr class="hr-s">
        <div class="phone-viewport" id="railOut">
          <div>
            <md-list>
              <md-list-item id="showvehicleBooking" class="md-button-color-toggle md-active">
                <span>DOCUMENTATION - CARGO ARRIVAL NOTICE</span>

                <md-list-expand>
                  <md-list>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="70"></md-layout>

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Current Date & Time</label>
                          <b-form-input :formatter="capitalizeAll" disabled v-model="AuthModel.currentDate"></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Important Notice</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor
                            style="width:100% !important;height:190px !important"
                            v-model="AuthModel.importantNotice"
                          ></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Notice Text</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor
                            style="width:100% !important;height:80px !important"
                            v-model="AuthModel.noticeText"
                          ></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Shipper Name</label>
                          <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.exporterName"></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Shipping Line Name</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="importerName"
                            name="importerName"
                            v-model="AuthModel.shippingLineName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>MBL NO</label>
                          <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.mblNo"></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>HBL NO</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="mblNo1"
                            name="mblNo1"
                            v-model="AuthModel.secondBLNumber"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Consigned to.</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="containerSealNo" v-model="AuthModel.consignedTo"></quill-editor>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Vessel/Voyage</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="containerSealNo" v-model="AuthModel.vesselNameVoyage"></quill-editor>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Container No.</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="containerSealNo" v-model="AuthModel.containerSealNo"></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Origin</label>
                          <b-form-input :formatter="capitalizeAll" id="Origin" name="Origin" v-model="AuthModel.Origin"></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Destination</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="Destination"
                            name="Destination"
                            v-model="AuthModel.Destination"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="10">
                        <md-layout md-flex="100">
                          <label>CBM</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="Measurement"
                            name="Measurement"
                            v-model="AuthModel.Measurement"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>SMTP No.</label>
                          <b-form-input :formatter="capitalizeAll" id="smtpNo" name="smtpNo" v-model="AuthModel.smtpNo"></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>IGM No.</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="gatewayIgmNo"
                            name="gatewayIgmNo"
                            v-model="AuthModel.gatewayIgmNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20">
                        <label>IGM Date</label>
                        <date-picker
                          lang="en"
                          name="weighingDate"
                          id="weighingDate"
                          type="datetime"
                          format="YYYY-MM-DD hh:mm a"
                          v-model="AuthModel.gatewayIgmDate"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20">
                        <label>Arrival Date</label>
                        <date-picker
                          lang="en"
                          name="weighingDate"
                          id="weighingDate"
                          type="datetime"
                          format="YYYY-MM-DD hh:mm a"
                          v-model="AuthModel.etaToPort"
                        ></date-picker>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="10">
                        <md-layout md-flex="100">
                          <label>Weight</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="grossWeight"
                            name="grossWeight"
                            v-model="AuthModel.grossWeight"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Local IGM No.</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="localIgmNo"
                            name="localIgmNo"
                            v-model="AuthModel.localIgmNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="25">
                        <label>Local IGM Date.</label>
                        <date-picker
                          lang="en"
                          name="weighingDate"
                          id="weighingDate"
                          type="datetime"
                          format="YYYY-MM-DD hh:mm a"
                          v-model="AuthModel.localIgmDate"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="5"></md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>No of packages</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="containerSealNo" v-model="AuthModel.noOfContainer"></quill-editor>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Actual Consignee</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="consignee" v-model="AuthModel.consignee"></quill-editor>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Commodity</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor ref="commodity" v-model="AuthModel.commodity"></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Remarks</label>
                          <b-form-textarea :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.remarks"></b-form-textarea>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <h4>Invoice Details :</h4>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Invoice No.</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="importerName"
                            name="importerName"
                            v-model="AuthModel.invoiceNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="10">
                        <md-layout md-flex="100">
                          <label>Quantity</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="invQuantity"
                            name="invQuantity"
                            v-model="AuthModel.invQuantity"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Description</label>
                          <b-form-textarea :formatter="capitalizeAll"
                            id="invDescription"
                            name="invDescription"
                            v-model="AuthModel.invDescription"
                          ></b-form-textarea>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <hr class="hr-border">

                    <md-layout md-gutter>
                      <md-layout md-flex="40"></md-layout>

                      <md-layout md-flex="20">
                        <md-button
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                          @click="addAuthDocumentation"
                          id="addButtonLoaderAuth"
                        >Submit Cargo Notice</md-button>

                        <md-spinner md-indeterminate id="loaderAuth" style="display:none"></md-spinner>
                      </md-layout>
                      <md-layout md-flex="15"></md-layout>

                      <md-layout md-flex="20" v-if="AuthModel.ffCargoId!=''">
                        <md-button
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                          @click="Print('CargoArival',AuthModel.uploadCargoDoc)"
                          id="addButtonLoaderAuth"
                        >Print</md-button>
                      </md-layout>
                    </md-layout>
                  </md-list>
                </md-list-expand>
              </md-list-item>
            </md-list>
          </div>
        </div>-->
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
      @close="ProceedSail"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffSeaImportId") != "" &&
      this.$sessionsStorage.get("editffSeaImportId") != undefined
    ) {
      this.$store.dispatch("setCurrentRoute", "/seaImport/documentationDo");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      NocModel: {
        ffDoId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        receivingDate: "",
        nocPreparation: "",
        currentDate: "",
        mblNo: "",
        hblNo: "",
        importerName: "",
        containerSealNo: "",

        uploadNocDoc: "",
        containerInfo: "",
        commodity: "",
        localIgmNo: "",
        localIgmDate: "",
        smtpNo: "",
        gatewayIgmNo: "",
        gatewayIgmDate: ""
      },
      AuthModel: {
        ffCargoId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        currentDate: "",
        shippingLineName: "",
        consignedTo: "",
        mblNo: "",
        exporterName: "",
        secondBLNumber: "",
        vesselNameVoyage: "",
        containerSealNo: "",
        Origin: "",
        Destination: "",
        Measurement: "",
        smtpNo: "",
        importantNotice: "",
        noticeText: "",
        gatewayIgmDate: "",
        etaToPort: "",
        grossWeight: "",
        gatewayIgmNo: "",
        localIgmNo: "",
        localIgmDate: "",
        commodity: "",
        remarks: "",
        noOfContainer: "",
        consignee: "",
        invoiceNo: "",
        invQuantity: "",
        invDescription: "",
        uploadCargoDoc: "",
        containerInfo: ""
      },
      NormalseaImportDataModel: {},

      railOutTableArray: [],
      getContainerList: [],
      deleteId: "",
      showVisible: false,

      validate: true,
      validateRail: true,
      toMain: "",
      toMainAuth: ""
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    quillEditor
  },
  computed: {},
  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },

    Print(dir, value) {
      window.open(`${this.docURL}/SeaImport/` + dir + "/" + value);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },

    ProceedSail() {},

    validateFFExport() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    showOverflow() {},

    addNocDocumentation() {
      this.NocModel["containerDetail"] = this.getContainerList;
      if (this.validate != false) {
        $("#addButtonLoaderNoc").css("display", "none");
        $("#loaderNoc").css("display", "block");
        console.log(this.NocModel);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addDODocNew.php`,
          data: JSON.stringify(this.NocModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loaderNoc").css("display", "none");
              $("#addButtonLoaderNoc").css("display", "block");
              if (this.NocModel.ffDoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.NocModel.ffDoId = data.ffDoId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addAuthDocumentation() {
      if (this.validate != false) {
        $("#addButtonLoaderAuth").css("display", "none");
        $("#loaderAuth").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addCargoDoc.php`,
          data: JSON.stringify(this.AuthModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loaderAuth").css("display", "none");
              $("#addButtonLoaderAuth").css("display", "block");

              if (this.AuthModel.ffCargoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.AuthModel.ffCargoId = data.ffCargoId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    onClose22() {},

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    getData() {
      let vehicle_drive = {
        ffImportId: this.$sessionsStorage.get("editffSeaImportId")
      };
      this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetch_DO_Cargo_Documentation.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            Object.keys(data.NormalseaImportData[0]).map(x => {
              this.NormalseaImportDataModel[x] =
                data.NormalseaImportData[0][x] || "";
            });

            if (data.NocDocumentArray.length > 0) {
              Object.keys(this.NocModel).map(x => {
                this.NocModel[x] = data.NocDocumentArray[0][x] || "";
              });
            } else {
              this.NocModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              if (data.NormalseaImportData[0].containerInfo == "fcl") {
                this.toMain = "<p>HAPAG Lloyd India Pvt. Ltd</p>";
                this.NocModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
                this.NocModel.hblNo =
                  data.NormalseaImportData[0].secondBLNumber;
              } else {
                this.toMain =
                  "<p><<--From Input Coloader Name->></p><p><<--From Input Coloader Address->></p>";
                this.NocModel.mblNo =
                  data.NormalseaImportData[0].lclmasterBLNumber;
                this.NocModel.hblNo =
                  data.NormalseaImportData[0].secondBLNumber;
              }
              this.NocModel.currentDate = this.formatDate(new Date());

              if (data.LastPreparationNoc.length > 0) {
                this.NocModel.nocPreparation =
                  data.LastPreparationNoc[0].nocPreparation;
              } else {
                this.NocModel.nocPreparation =
                  "<br/><p>To,</p><p>The Manager,</p><p>ICD TKD/DADRI/LONI/PPG/GDL/PATLI/REWARI/KHATUWAS/PIYALA/ACTL/BAWAL………………….</p><p>Inland Container Depot – Address</p></br><p>Please arrange to Deliver the following to <b> <<--From Input Importer->></b>  upon submission of Original Delivery Order and collection of all your applicable charges.</p><br/><b><p>MBL No.:<<--From Input MBL->></p><p>HBL NO.:<<--From Input HBL->></p><p>Commodity:<<--From Input Commodity->></p><p>Gateway IGM No. / Date:<<--From Input GateIGM->> / <<--From Input GateIGMDate->></p><p>Local IGM No. / Date:<<--From Input IGMNO->> / <<--From Input IGMDate->></p><p>SMTP / Line No:<<--From Input SMTPNO->></p></b><<--Container_Details_Table->><p></br> <b>The delivery order is valid till – XX/XX/XXXX……..OPEN……AS PER SHIPPING LINE</b></p></br><p>Delivery Order issued against a suitable Bank Guarantee / Seaway Bill / Original Bill of Lading duly endorsed in possession and is subject to all clause/Terms and condition of carrier Bill of Lading,</p><p>All Liabilities / responsibilities of mis-declaration, mis-representation, concealment or the likes thereof which may be brought to attention of any liability at any later date shall be the responsibility of the Shipper / Consignee or their agents who have been in possession of the title of the above mentioned goods.<br/></p></br><p><b>For Pridel Private Limited</p><p>Auth. Signatory.</b></p>";
              }

              this.NocModel.importerName =
                data.NormalseaImportData[0].importerName;
              this.NocModel.containerSealNo =
                data.NormalseaImportData[0].containerSealNo;
              this.NocModel.coLoaderName =
                data.NormalseaImportData[0].coLoaderNameNew;
              this.NocModel.coloaderAdd = data.NormalseaImportData[0].address;
            }

            if (data.AuthDocumentArray.length > 0) {
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.AuthDocumentArray[0][x] || "";
              });
              this.NocModel.commodity = data.AuthDocumentArray[0].commodity;
              this.NocModel.gatewayIgmNo =
                data.AuthDocumentArray[0].gatewayIgmNo;
              this.NocModel.gatewayIgmDate =
                data.AuthDocumentArray[0].gatewayIgmDate;
              this.NocModel.localIgmNo = data.AuthDocumentArray[0].localIgmNo;
              this.NocModel.localIgmDate =
                data.AuthDocumentArray[0].localIgmDate;
              this.NocModel.smtpNo = data.AuthDocumentArray[0].smtpNo;
            } else {
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.NormalseaImportData[0][x] || "";
              });

              if (data.NormalseaImportData[0].containerInfo == "fcl") {
                this.AuthModel.mblNo =
                  data.NormalseaImportData[0].firstBLNumber;
              } else {
                this.AuthModel.mblNo =
                  data.NormalseaImportData[0].lclmasterBLNumber;
              }
              this.AuthModel.currentDate = this.formatDate(new Date());

              if (data.LastAuthLetter.length > 0) {
                this.AuthModel.importantNotice =
                  data.LastAuthLetter[0].importantNotice;
                this.AuthModel.noticeText = data.LastAuthLetter[0].noticeText;
              } else {
                this.AuthModel.importantNotice =
                  "<p>1. THE BELOW SHIPMENT ARRIVERD / EXPECTED AT NHAVA SHEVA ON DATE 20/04/2012.<br/>PLEASE KEEP IN TOUCH WITH US FOR FURTHER INFORMATION AND ARRANGE TO PRESENT ORIGINAL / ENDORESED DOCUMENT AND OBTAIN DELIVERY ORDER AGAINST PAYMENT OF ALL CHARGES THROUGH D.D.</p><p>2 A) PELASE PRODUCE LETTER OF AUTHORITY WHILE APPROCHING US FOR DOCUMENTS AND DO.<br/>  &nbsp;&nbsp;&nbsp;B) FOR PERSONAL EFFECTS PLEASE PRODUCE YOUR PASSPORT AND AUTHORITY LETTER  AT THE TIME OF COLLECTING DELIVERY ORDER. </p><p>3. PAYMENT IS TO BE MADE STRICTY IN DD/ CASH ACCORDING TO OUR FREIGHT INVOICE. </p><p>4 EXCHANGE RATE APPLIED IS SUBJET TO ANY UPWARD REVISION. </p>";

                this.AuthModel.noticeText =
                  "<p>Dear Sir / Madam,</p><br/><p>We have the please in advising you arrivial of the following shipment to you under our consolidation service which are as per details below .</p>";

                this.AuthModel.consignedTo =
                  "<p>" +
                  data.NormalseaImportData[0].importerName +
                  ",</p><p>" +
                  data.NormalseaImportData[0].corporateAddress +
                  ".</p>";
              }
            }
            if (data.multiContainerData.length > 0) {
              this.getContainerList = data.multiContainerData;
            }
            console.log(data);
            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      this.$router.push({
        path: "/seaImport/ffSeaImportExecution"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ImportDOorderDocumentation.vue?f1d03d12